<template>
  <div id="app" v-cloak>
    <Query
      :keyword="key"
      :city="city"
      ref="query"
      :shadedWords="shadedWords"
      :autoFocus="autoFocus"
      @handlerSearch="onSearch"
      @handlerInput="onInput"
      @handlerFoucs="onFocus"
    ></Query>
    <UserLocation
      v-if="key && !fastMatch && !pastRecord && addressGray"
      ref="userLocation"
      :key="locationKey"
      :entityFlag="entityFlag"
      :cityInfo="cityInfo"
      :userAddressList="userAddressList"
      :positionAddress="positionAddress"
      :isGetIpAddress="isGetIpAddress"
      :provinceList="provinceList"
      :singleChannel="single"
      :path="path"
      @handlePosition="handlePosition"
    />
    <div class="tab-loading" v-if="tabsLoading && key && !single"><TabSkeleton /></div>
    <Tab ref="tabs" v-if="key && tabs.length && !single" :tabs="tabs" @handlerClear="onClear"></Tab>
    <FastMatch v-if="fastMatch" @handlerSearch="onSearch"></FastMatch>
    <PastRecord
      v-if="pastRecord"
      @handlerSearch="onSearch"
      @handlerBlur="onBlur"
    ></PastRecord>
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getQueryString,
  unionFlag,
  getUserLoaction,
  checkFromChannel,
  getChannelText,
  getChannelRouter,
  checkUnifyShop,
  throttleFn,
} from "./utils";
import { checkEnv, getCatchAddress, getLocation, initAddressDF, } from 'dflocationsdk';
import { getAddressDetail } from "./utils/locationApi/location";
import { checkXcx, checkLeFuXcx } from "./utils/checkXcx";
import { getCookieAddressInfo } from "./utils";
import { postUnionConfig, getWxSignatureUrl } from "./assets/js/api";
import Tab from "./components/Tab";
import Query from "./components/Query";
import FastMatch from "./components/FastMatch";
import PastRecord from "./components/PastRecord";
import UserLocation from "./components/Location.vue";
import TabSkeleton from "./components/TabSkeleton";
import qs from "qs";
import { publicFunc } from "./utils/func";

export default {
  name: "App",
  provide() {
    return {
      reload: this.onReload
    };
  },
  data() {
    let catchCity = getCookieAddressInfo('cityId') || getQueryString("city") || "145"
    return {
      fastMatch: false,
      pastRecord: false,
      autoFocus: true,
      key: getQueryString("key"),
      city:catchCity,
      isRouterAlive: true,
      isGetIpAddress: false, // 获取用户精准定位是否成功
      positionAddress: {},
      entityFlag: false, // 是否是实体路由
      locationCityId: getCookieAddressInfo('cityId') || '',
      locationKey: Math.random(), // 用户刷新子组件
      single: getQueryString('singleChannel'),
      path: getQueryString("path"),
      shadedWords: getQueryString('shadedWords'), // 底纹词
    };
  },
  created() {
    // 判断是否是频道内搜索
    const singleChannel = getQueryString("singleChannel")
    if (singleChannel) {
      this.$store.dispatch("setSingle");
    }

    initAddressDF(false,null,false,'',true).then(res=>{
      if(res){
        this.city = res.cityId
      }
    })

    const _env = checkEnv();
    const _this = this;
    try {
      // 去除浏览器定位弹窗
      if (_env != 'browser') {
        getLocation(_env, function(val) {
          if (val && val.location) {
            localStorage.setItem("systemLoaction", JSON.stringify({ location:val.location }));
            // 通过经纬度获取用户定位的地址 金毅getAddressReParseInfo接口
            _this.getNewAddress(val)
          }
        })
      }
    } catch (error) {
      console.log(error)
    }
    // getLocation(_env, function(val) {
    //   if(val.code!==-1){
    //   localStorage.setItem("systemLoaction", JSON.stringify({ location:val.location }));}
    // });

    const isOpenInWechat = this.isInWechat();
    const isOpenInQyWechat = this.isInQyWechat();
    // 判断当前环境是否在微信中
    if (isOpenInWechat || isOpenInQyWechat) {
      const _window = window;
      //获取wx api 签名
      // const that = this;
      const type = navigator.userAgent.match(/wxwork/i) ? 2 : 1;
      const params = {
        caller: type,
        url: window.location.href.split("#")[0]
      };
      getWxSignatureUrl(params).then(res => {
        console.log(res, "abcssss");
        console.log(res.data.body, "getSignature");
        if (res && res.data.body) {
          // const { Data = {} } = res;
          const Data = res.data.body;
          _window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: Data.appId, // 必填，公众号的唯一标识
            timestamp: Data.timestamp, // 必填，生成签名的时间戳
            nonceStr: Data.nonceStr, // 必填，生成签名的随机串
            signature: Data.signature, // 必填，签名
            jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
          });
        }
      });
    }

    if (localStorage.getItem("RETURN_URL")) {
        localStorage.removeItem("RETURN_URL");
      }
    const returnURL = getQueryString("return_url") || getQueryString('returnUrl');
    this.unionConfig();
    let healthSearch = 0;
    const union = unionFlag() || sessionStorage.getItem("dffl_union");
    if (returnURL) {
      if (!union || checkUnifyShop()) {
        localStorage.setItem("RETURN_URL", decodeURIComponent(returnURL));
      }
      if (returnURL.includes("/health/index")) healthSearch = 1;

      if (returnURL && getQueryString("key")) { // 切换城市会刷新页面
        this.autoFocus = false;
      }
    } else {
      this.autoFocus = false;
    }
    if (this.key) {
      const data = {
        key: this.key,
        city: this.city,
        healthSearch
      };
      if (checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
        data.customization = 1;
        if (!data.productTypes) {
          // console.log(localStorage.getItem("RETURN_URL"));
          data.productTypes = checkFromChannel();
        } else if (!Array.isArray(data.productTypes)) {
          let arr = [data.productTypes];
          data.productTypes = arr;
        }
      }

      if (data.cardChoose) {
        data.isCardRights = data.cardChoose;
      }

      if (singleChannel) {
        data.singleChannel = singleChannel
        data.productTypes = getChannelText(singleChannel)
      }

      this.$store.commit("initParmasAsync", data);

      const path = location.pathname.replace("/ms", "");
      const name = path.substring(1)

      if (!name || name && name.length < 1) {
        this.$store.dispatch("initDataAsync", data);
      }
    }
    this.$store.dispatch("checkLogin");
    // this.$store.dispatch("getCityList");
    // this.$store.dispatch("getAllDistrict");
    this.$store.dispatch("getAddressGray");
  },
  computed: {
    ...mapState({
      tabs: state => state.tabs,
      tabsLoading: state => state.tabsLoading,
      cityInfo: state => state.cityInfo,
      userAddressList: state => state.userAddressList,
      provinceList: state => state.provinceList,
      addressGray: state => state.addressGray,
      singleChannel: state => state.singleChannel,
    })
  },
  components: {
    Tab,
    Query,
    FastMatch,
    PastRecord,
    UserLocation,
    TabSkeleton,
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        console.log("val",val,oldVal);
        this.path = this.getPath()
        this.key= getQueryString("key")
        // 路由变化，判断当前路由是否是实体tab
        if (val.name != oldVal.name) {
          if (oldVal.name){
            this.$store.dispatch("clearAllQuery",{});
          }
          if (!val.name) {
            this.key = '';
          }
          if (this.constant.entityPath.includes(val.name)) {
            this.entityFlag = true;
          } else {
            this.entityFlag = false;
          }
          // console.log('让我看看路由变成什么样子了', val.name)
        }
      },
      deep: true
    },
    cityInfo: {
      handler: function(val, oldVal) {
        if (val && val.cityList) {
          this.locationKey = Math.random()
        }
      },
      deep: true
    },
    isGetIpAddress: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          this.locationKey = Math.random()
        }
      },
      deep: true
    },
    positionAddress: {
      handler: function(val, oldVal) {
        if (val) {
          // this.locationKey = Math.random()
        }
      },
      deep: true
    },
    userAddressList: {
      handler: function(val, oldVal) {
        if (val.length != oldVal.length) {
          this.locationKey = Math.random()
        }
      },
      deep: true
    },
    provinceList: {
      handler: function(val, oldVal) {
        if (val.length != oldVal.length) {
          this.locationKey = Math.random()
        }
      },
      deep: true
    },
    singleChannel: {
      handler: function(val, oldVal) {
        if (val) {
          this.single = val
        }
      },
      deep: true
    },
  },
  methods: {
    getBFD() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return union && !checkUnifyShop();
    },
    getPath() {
      const path = location.pathname.replace("/ms", "");
      const name = path.substring(1)
      return name
    },
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem("dffl_union");
      return publicFunc.getCookie("df_lang") == "en-US" && (union || checkUnifyShop());
    },
    isInWechat() {
      const ua = navigator.userAgent.toLowerCase();
      if (
        ua.match(/MicroMessenger/i) == "micromessenger" &&
        ua.match(/wxwork/i) != "wxwork"
      ) {
        return true;
      }
      return false;
    },
    isInQyWechat() {
      const ua = navigator.userAgent.toLowerCase();
      if (
        ua.match(/wxwork/i) &&
        ua.match(/wxwork/i).includes("wxwork") &&
        ua.match(/MicroMessenger/i) &&
        ua.match(/MicroMessenger/i).includes("micromessenger")
      ) {
        return true;
      }
      return false;
    },
    // 获取用户精准四级地址
    getNewAddress(locationInfo) {
      const _this = this;
      getAddressDetail('location', locationInfo.location).then((res) => {
        if (res.Data.data) {
          _this.isGetIpAddress = true;
          // 当前定位地址需要保存下来
          _this.positionAddress = res.Data.data
        }
      })
    },
    unionConfig() {
      const unionCode = unionFlag();
      const data = {
        unionFlag: unionCode || checkUnifyShop() ? 1 : 0,
        union: unionCode
      };
      postUnionConfig(data).then(({ data }) => {
        window.union_scale = data.scale || 1;
        window.union_icon = data.icon || "";
        window.union_name = data.name || "福豆";
      });
    },
    toHome(parmas) {
      const path = location.pathname.replace("/ms", "");
      const search = qs.parse(location.search.replace(/^\?/, ''))

      const query = {
        ...search,
        ...(search.return_url && {return_url: encodeURIComponent(decodeURIComponent(search.return_url))})
      };

      // decodeURIComponent(location.search)
      //   .replace("?", "")
      //   .split("&")
      //   .map((item) => item.split("="))
      //   .map((item) => (query[item[0]] = item[1]));

      let def = this.tabs
      let pathName = ''

      if (parmas.singleChannel) {
        pathName = getChannelRouter(parmas.singleChannel)
      } else if (def && def.length) {
        this.index = def[0].index;
        pathName = def[0].path;
      } else {
        pathName = 'home'
      }
      const locationPath = window.location.pathname;
      if (locationPath === '/ms/' || locationPath === '/ms'){
        this.$router
        .push({
          name: pathName,
          query: {...query, ...parmas}
        })
        .catch(() => {});
      } else {
        this.$router
        .replace({
          name: pathName,
          query: {...query, ...parmas}
        })
        .catch(() => {});
      }

    },
    onSearch(params, immediate, index, routeInfo) {
      let data = params
      this.fastMatch = immediate;
      this.pastRecord = immediate;

      const { query } = this.$route;
      const returnURL = "return_url";
      const returnUrl = getQueryString("return_url");
      let healthSearch = 0;
      if (returnUrl && returnUrl.includes("/health/index")) healthSearch = 1;

      if (query.hasOwnProperty(returnURL)) {
        delete query[returnURL];
      }

      data.healthSearch = healthSearch;
      if (checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
        data.customization = 1;
        if (!data.productTypes) {
          // console.log(localStorage.getItem("RETURN_URL"));
          data.productTypes = checkFromChannel();
        } else if (!Array.isArray(data.productTypes)) {
          let arr = [data.productTypes];
          data.productTypes = arr;
        }
      } else if (data.productTypes) {
        let arr = [data.productTypes];
        data.productTypes = arr;
      } else {
        data.productTypes = [];
      }

      if (data.cardChoose) {
        data.isCardRights = data.cardChoose;
      }

      const singleChannel = this.singleChannel || getQueryString('singleChannel')
      if (singleChannel) {
        data.singleChannel = singleChannel
        data.productTypes = getChannelText(singleChannel)
      }

      const isSamKey = this.key === data.key;
      if (data.key) {
        this.key = data.key;
        if (!immediate) {
          if (index) { // 有值代表搜索， 没有值代表快搜
            const path = location.pathname.replace("/ms/", "")
            this.$store.commit("initParmasAsync", data)

            if (path === routeInfo.path) {
              if (!isSamKey) {
                this.$router
                .replace({
                  name: routeInfo.path,
                  query: { ...query, ...data, index, }
                })
                this.onReload()
              } else {
                this.onReload()
              }
            } else {
              this.$router
                .replace({
                  name: routeInfo.path,
                  query: { ...query, ...data, index, },
                })
                .catch(() => { })
            }
          }
          else {
            this.toHome(data)
            this.$store.commit("initParmasAsync", data);
            this.$store.commit("setRecordWord", data);
            this.onReload()
          }
          return
        }

        this.$store.commit("initParmasAsync", data);
        this.$store.commit("setRecordWord", data);
        this.onReload()
      } else {
        // this.$toast(TLang("搜索关键字不能为空", "result"));
      }

      this.$refs.query.wd = this.key;
    },
    onClear(data) {
      this.$store.dispatch("updateLocationAsync", data);
      this.$store.dispatch("updateLxPriceAsync", {});
      this.$store.dispatch("updateLxLocationAsync", '');
    },
    onInput(data) {
      const size = data.key.trim().length;
      const LOCALRECORD = localStorage.getItem("record") || !this.getBFD();

      this.fastMatch = size > 0 ? true : false;
      this.pastRecord = size < 1 && LOCALRECORD ? true : false;

      if (checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
        // console.log(localStorage.getItem("RETURN_URL"));
        data.productTypes = checkFromChannel();
        data.customization = 1;
      }

      if (this.single) {
        data.singleChannel = this.single
        // data.productTypes = getChannelText(this.single)
      }

      if (this.fastMatch) {
        throttleFn(this.$store.dispatch("fastMatchAsync", data), 300)
      }
    },
    onFocus(data) {
      const size = data.key.trim().length;
      // 有历史记录或官网，展示历史记录浮窗
      const LOCALRECORD = localStorage.getItem("record") || !this.getBFD();

      this.fastMatch = size > 0 ? true : false;
      this.pastRecord = size < 1 && LOCALRECORD ? true : false;

      if (checkFromChannel() && checkXcx() && !checkLeFuXcx()) {
        // console.log(localStorage.getItem("RETURN_URL"));
        data.productTypes = checkFromChannel();
        data.customization = 1;
      }

      if (this.single) {
        data.singleChannel = this.single
        // data.productTypes = getChannelText(this.single)
      }

      if (this.fastMatch) {
        throttleFn(this.$store.dispatch("fastMatchAsync", data), 300);
      }
    },
    onBlur(immediate) {
      this.fastMatch = immediate;
      this.pastRecord = immediate;
    },
    onReload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    handlePosition(data) {
      this.positionAddress = data;
    }
  }
};
</script>
<style lang="less">
@375: 320/375;
@import "./assets/styles/base/reset.less";
html,
body,
#app {
  height: 100%;
}
#app {
  overflow: hidden;
}
[v-cloak] {
  display: none !important;
}
.cs {
  position: absolute;
  top: 88px * @375;

  right: 0;
  bottom: constant(safe-area-inset-bottom);
  bottom: env(safe-area-inset-bottom);
  left: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  &-top {
    top: 128px * @375;
  }
  &-noTab-top {
    top: 84px * @375;
  }
  &-noTab {
    top: 44px * @375;
  }
  &-active {
    overflow: hidden;
  }
  &-shopCat {
    padding-bottom: calc(88px * @375 + constant(safe-area-inset-bottom));
    padding-bottom: calc(88px * @375 + env(safe-area-inset-bottom));
  }
}
.app-shopCar {
  .cs {
    padding-bottom: calc(34px * @375 + constant(safe-area-inset-bottom));
    padding-bottom: calc(34px * @375 + env(safe-area-inset-bottom));
  }
}
.tab-loading {
  position: relative;
  z-index: 99;
}
</style>
